import axios, { AxiosInstance } from 'axios';
import { WEB_API_PAY_URL, WEB_API_URL } from 'services/constants/env';
import { store } from 'redux/store';
import { getAuth } from 'redux/reducers/auth/selectors';
import { onError } from './interceptor/onError';
import { onSuccess, onSuccessRefresh } from './interceptor/onSuccess';

// ==========================================:
export const http: AxiosInstance = axios.create({
	baseURL: WEB_API_URL,
	headers: {
		'Access-Control-Allow-Origin': '*',
		'Content-Type': 'application/json',
		Accept: 'application/json',
		// 'X-Merchant-Id': 'AF-00008985@898',
	},
});

http.interceptors.request.use(onSuccess);
http.interceptors.response.use((response) => response, onError);

// ==========================================:

export const httpRefresh: AxiosInstance = axios.create({
	baseURL: WEB_API_URL,
	headers: {
		'Access-Control-Allow-Origin': '*',
		'Content-Type': 'application/json',
		Accept: 'application/json',
	},
});
httpRefresh.interceptors.request.use(onSuccessRefresh);
httpRefresh.interceptors.response.use((response) => response, onError);

// ==========================================:

export const httpPay: AxiosInstance = axios.create({
	baseURL: WEB_API_PAY_URL,
	headers: {
		'Access-Control-Allow-Origin': '*',
		'Content-Type': 'application/json',
		Accept: 'application/json',
		// 'X-Merchant-Id': 'AF-00008985@898',
	},
});

httpPay.interceptors.request.use(onSuccess);
httpPay.interceptors.response.use((response) => response, onError);
